export const FORMES = [
  ["rond", "Rond"], ["ovale", "Ovale"], ["ovoide", "Ovoïde"],
  ["triangle", "Triangle"], ["autre", "Autre sur demande"], ["conseil", "À conseiller"],
];

export const DIAMETRES = [
  ["40", "40 cm"], ["45", "45 cm"], ["50", "50 cm"],
  ["60", "60 cm"], ["autre", "Autre sur demande"],
];

export const BOIS = [["bouleau", "Bouleau"], ["hetre", "Hêtre"], ["conseil", "À conseiller"]];

export const PEAUX = [
  ["chevre", "Chèvre"], ["cerf", "Cerf"], ["cheval", "Cheval"],
  ["bison", "Bison"], ["autruche", "Autruche"], ["biche", "Biche"],
  ["chamois", "Chamois"], ["lama", "Lama"], ["daim", "Daim"],
  ["sanglier", "Sanglier"], ["autre", "Autre"], ["conseil", "À conseiller"],
];

export const LACAGES = [
  ["branches", "À branches"], ["triskel", "Triskel — 3 branches tournantes"],
  ["adn", "ADN — modèle distinct à 4 branches"], ["arbre", "Arbre de vie"],
  ["conseil", "À conseiller"],
];

export const BRANCHES = [["3", "3 branches"], ["4", "4 branches"], ["5", "5 branches"], ["6", "6 branches"], ["8", "8 branches"]];
export const ORIENTATIONS = [["droites", "Droites"], ["tournantes", "Tournantes — effet de mouvement"]];
export const MATIERES_LACAGE = [["peau", "Lanières de peau"], ["paracorde", "Paracorde synthétique"], ["jute", "Cordelette de jute"], ["conseil", "À conseiller"]];

export const SONORITES = [["grave", "Grave & profonde"], ["chaude", "Chaude & enveloppante"], ["vive", "Vive & précise"], ["conseil", "Je souhaite être conseillé"]];
export const PRIORITES = [["confort", "Confort de jeu"], ["encombrement", "Encombrement"], ["apparence", "Apparence"]];

export const labelOf = (options, value) => options.find(([id]) => id === value)?.[1] || "Non précisé";
export const labelsOf = (options, values = []) => values.length ? values.map((v) => labelOf(options, v)).join(", ") : "Non précisé";